import { FaRegCalendarAlt } from "react-icons/fa";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import styles from "./DateInput.module.css";

const DateInput = ({

    label,

    value,

    onChange,

    error,

    touched,

    placeholder = "انتخاب تاریخ",

    helperText,

    format = "YYYY/MM/DD",

    minDate,

    maxDate,

    editable = false,

    clearable = false,

    disabled = false,

    fullWidth = true,

}) => {

    return (

        <div

            className={`${styles.wrapper} ${

                fullWidth ? styles.fullWidth : ""

            }`}

        >

            {

                label &&

                <label className={styles.label}>

                    {label}

                </label>

            }

            <div className={styles.inputWrapper}>

                <FaRegCalendarAlt

                    className={styles.icon}

                />

                <DatePicker

                    value={value}

                    onChange={onChange}

                    format={format}

                    calendar={persian}

                    locale={persian_fa}

                    editable={editable}

                    minDate={minDate}

                    maxDate={maxDate}

                    disabled={disabled}

                    placeholder={placeholder}

                    inputClass={styles.input}

                    containerClassName={styles.container}

                />

                {

                    clearable && value && (

                        <button

                            type="button"

                            className={styles.clearButton}

                            onClick={() => onChange("")}

                        >

                            ×

                        </button>

                    )

                }

            </div>

            {

                helperText && !(touched && error) && (

                    <small className={styles.helper}>

                        {helperText}

                    </small>

                )

            }

            {

                touched && error && (

                    <small className={styles.error}>

                        {error}

                    </small>

                )

            }

        </div>

    );

};

export default DateInput;